import styled from "styled-components";
import { Colors } from "configs";

export const Page = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #f5fbfa;
  min-height: 80vh;
`;

export const Banner = styled.div`
  position: relative;
  width: 100%;
  min-height: 380px;
  display: flex;
  align-items: flex-end;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  background-color: ${Colors.primary};

  ::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 60, 57, 0.25) 0%,
      rgba(0, 50, 48, 0.85) 100%
    );
  }

  @media (max-width: 768px) {
    min-height: 300px;
  }
`;

export const BannerInner = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  padding: 110px 6vw 40px 6vw;
`;

export const TopBar = styled.div`
  position: absolute;
  z-index: 3;
  top: 18px;
  left: 0;
  right: 0;
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 6vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TopButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  font-weight: 700;
  font-size: 0.9rem;
  padding: 8px 16px;
  border-radius: 50px;
  cursor: pointer;
  transition: 0.3s all;

  :hover {
    background: rgba(255, 255, 255, 0.32);
  }
`;

export const BannerTitle = styled.h1`
  font-family: "Montserrat", "Nunito", sans-serif;
  color: #fff;
  font-weight: 800;
  font-size: 2.4rem;
  line-height: 1.15;
  margin: 0;
  max-width: 760px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);

  @media (max-width: 768px) {
    font-size: 1.7rem;
  }
`;

export const BannerSummary = styled.p`
  color: rgba(255, 255, 255, 0.92);
  font-size: 1.12rem;
  line-height: 1.5;
  margin: 14px 0 0 0;
  max-width: 680px;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.35);
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1120px;
  margin: -40px auto 0 auto;
  padding: 0 6vw 80px 6vw;
  position: relative;
  z-index: 4;
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 28px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 16px 40px -18px rgba(0, 95, 90, 0.28);
  border: 1px solid #eef2f1;
  padding: 28px;
`;

export const SideColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;

  @media (min-width: 901px) {
    position: sticky;
    top: 120px;
  }
`;

export const SectionTitle = styled.h2`
  font-weight: 800;
  font-size: 1.4rem;
  color: ${Colors.primary};
  margin: 0 0 14px 0;
`;

export const Description = styled.p`
  font-size: 1.02rem;
  line-height: 1.7;
  color: ${Colors.secondary};
  white-space: pre-line;
  margin: 0;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Price = styled.span`
  font-family: "Montserrat", "Nunito", sans-serif;
  font-weight: 800;
  font-size: 2rem;
  color: ${Colors.greenCheck};
`;

export const OldPrice = styled.span`
  font-size: 1.05rem;
  color: ${Colors.secondary};
  text-decoration: line-through;
`;

export const DiscountNote = styled.div`
  margin-top: 6px;
  font-size: 0.9rem;
  color: ${Colors.secondary};
`;

export const BuyButton = styled.button`
  width: 100%;
  margin-top: 20px;
  background: #00b2a9;
  color: #fff;
  border: none;
  font-weight: 800;
  font-size: 1.1rem;
  padding: 14px;
  border-radius: 50px;
  cursor: pointer;
  transition: 0.3s all;

  :hover {
    background: #41c0ba;
  }
`;

export const SecureNote = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 14px;
  font-size: 0.85rem;
  color: ${Colors.secondary};
`;
